/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const DropdownWrapStyle = styled.div`
  position: relative;
  cursor: pointer;
  z-index: 100;

  &:hover {
    z-index: ${theme.zindex.topoftheworld};
  }
`;

export const DropdownWrapper = styled.div<{ width?: string }>`
  background: ${theme.color.background.ui01};
  transition: all 0.2s ease-in-out;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  border-radius: ${theme.radiusDefault} 0 ${theme.radiusDefault}
    ${theme.radiusDefault};
  top: 100%;
  right: 0;
  width: ${({ width }) => width ?? "100%"};
  z-index: 100;
  ${/* sc-selector */ DropdownWrapStyle}:hover & {
    opacity: 1;
    visibility: visible;
    box-shadow: ${theme.shadow.shadow04};
    border: solid 1px ${theme.color.background.ui04};
  }

  @media screen and (max-width: ${theme.breakpoints.xl}px) {
    width: ${({ width }) => width ?? "10rem"};
  }
`;

export const ArrowWrap = styled.div`
  display: block;

  svg {
    transition: transform 0.2s ease-in-out;
  }
  ${/* sc-selector */ DropdownWrapStyle}:hover & {
    svg {
      transform: rotate(180deg);
      transform-origin: center center;
    }
  }
`;

export const BoxWrap = styled.div`
  min-width: 5.5rem;
  color: ${theme.color.text.text01};
  background: ${theme.color.background.ui01};
  border-radius: 4px;
  transition: box-shadow 0.2s ease-in-out;
  ${/* sc-selector */ DropdownWrapStyle}:hover & {
    box-shadow: ${theme.shadow.shadow04};
  }
`;

export const DropList = styled.ul`
  border-radius: ${theme.radius.md};
  padding: 0.5rem;
  margin-bottom: 0;
`;

export const DropItem = styled.li`
  display: flex;
  align-items: center;
  justify-items: center;
  padding: 0.5rem 0.2rem;
  font-size: 16px;
  cursor: pointer;

  :hover {
    opacity: 0.7;
  }

  &:last-of-type {
    border-top: 1px solid ${theme.color.border.border01};
  }
`;

export const NotClickableDropItem = styled(DropItem)`
  cursor: default;
  display: flex;
  border-bottom: 1px solid ${theme.color.border.border01};

  :hover {
    opacity: 1;
  }
`;

export const DropButton = styled.button`
  flex: 1;
  padding: 0;
  background: none;
  display: flex;
  align-items: center;
  justify-items: center;
  border: none;
  cursor: pointer;
  color: ${theme.color.text.text01};

  &:focus {
    outline: none;
  }
`;

export const IconWrap = styled.div`
  display: flex;
  margin-right: 1rem;
`;
